import type { Procedure } from './api'

/** "Toxina botulínica × 2 · Preenchimento labial · 12 meses": a composição de um clube ou pacote. */
export function compositionLabel(procedure: Pick<Procedure, 'type' | 'items' | 'validityMonths'>) {
  if (procedure.type !== 'club_or_package' || procedure.items.length === 0) return null
  const items = procedure.items.map((item) =>
    item.quantity > 1
      ? `${item.catalogProcedure.name} × ${item.quantity}`
      : item.catalogProcedure.name,
  )
  if (procedure.validityMonths) {
    items.push(procedure.validityMonths === 1 ? '1 mês' : `${procedure.validityMonths} meses`)
  }
  return items.join(' · ')
}

/** "1 documento" · "2 documentos". */
export function documentsLabel(count: number) {
  return count === 1 ? '1 documento' : `${count} documentos`
}

export const CATEGORY_LABELS: Record<string, string> = {
  service_contract: 'Contrato de prestação de serviços',
  model_patient_contract: 'Contrato de paciente modelo',
  informed_consent: 'Termo de consentimento',
  anamnesis: 'Anamnese',
  standalone_form: 'Termo avulso',
  refund: 'Devolução',
  general_contract: 'Contrato',
  other: 'Outro documento',
}
